var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStepTypeInput = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20ZM11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7 11C7 10.4477 7.44772 10 8 10L14 10C14.5523 10 15 10.4477 15 11C15 11.5523 14.5523 12 14 12L8 12C7.44772 12 7 11.5523 7 11Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.0607 7.02512C11.4512 6.6346 12.0844 6.6346 12.4749 7.02512L16.4498 11L12.4749 14.9749C12.0844 15.3654 11.4512 15.3654 11.0607 14.9749C10.6702 14.5844 10.6702 13.9512 11.0607 13.5607L13.6214 11L11.0607 8.43933C10.6702 8.04881 10.6702 7.41564 11.0607 7.02512Z"
})));
export default SvgStepTypeInput;